import { ColDef } from 'ag-grid-community'
import { Button } from '@amzn/awsui-components-react'
import { ALLOCATION_WEEK_WIDTH_LIMIT } from '../../Constant'
import { DATA_TYPE, FILTER_TYPE } from '../grid/Constants'
import {
    addGeneralFilterParams,
    booleanCellRenderer,
    dashFallbackRenderer,
    dateCellRenderer,
} from '../grid/Utils'
import EmptyState from '../reusable/EmptyState'

export const createAllocationEmptyState = (canCreateAllocation: boolean) => () => (
    <>
        <br /> <br /> <br />
        <br /> <br /> <br />
        <EmptyState
            title='No allocation reports'
            subtitle='No allocation reports to display.'
            action={
                canCreateAllocation && (
                    <div style={{ pointerEvents: 'all' }}>
                        <Button href='/allocation' iconAlign='right'>
                            Set up allocation report
                        </Button>
                    </div>
                )
            }
        />
    </>
)

export const getHistoryColumnDefs = (allocationWeekCellRenderer): ColDef[] => {
    const columnDefs: ColDef[] = [
        {
            field: 'allocation_week',
            headerName: 'Allocation Week',
            cellRenderer: allocationWeekCellRenderer,
            filter: FILTER_TYPE.DATE,
            checkboxSelection: true,
            sort: 'desc',
            width: ALLOCATION_WEEK_WIDTH_LIMIT,
        },
        { field: 'total_allocation', headerName: 'Allocation', filter: FILTER_TYPE.NUMBER },
        { field: 'total_headcount', headerName: 'Headcount', filter: FILTER_TYPE.NUMBER },
        { field: 'submitted_by', headerName: 'Submitted By' },
        {
            field: 'submitted_at',
            headerName: 'Submitted At',
            cellRenderer: dateCellRenderer,
            filter: FILTER_TYPE.DATE,
        },
        {
            field: 'week_closed',
            headerName: 'Week Closed',
            cellDataType: DATA_TYPE.BOOLEAN,
            cellRenderer: booleanCellRenderer,
        },
        { field: 'note', headerName: 'System Note', sortable: false },
        { field: 'allocation_note', headerName: 'Allocation Note', sortable: false },
        { field: 'hr_detail_note', headerName: 'HC Detail Note', sortable: false },
    ]

    columnDefs.forEach((c) => {
        c.tooltipField = c.field
        c.cellRenderer ??= dashFallbackRenderer
        addGeneralFilterParams(c)
    })
    return columnDefs
}
